import { jsx as _jsx } from "react/jsx-runtime";
import { useMultiStyleConfig } from "@chakra-ui/react";
import { Tag } from "../../atoms/Tag";
import { SvgSpriteConsumer } from "../../atoms";
const File = ({ filename, onClose, }) => {
    const styles = useMultiStyleConfig("FileUploader");
    return (_jsx(Tag, Object.assign({ size: "sm", leftIcon: _jsx(SvgSpriteConsumer, { svgId: "plusCircleOutline16", size: 16 }), onClose: () => {
            onClose(filename);
        }, ellipsis: true, sx: styles.file }, { children: filename })));
};
export default File;
//# sourceMappingURL=File.js.map